import api from '@/components/mixins/baseApi';

/**
 * Избранное участников.
 *
 * Договорённость с бэком описана в docs/favorite-participants-api.md:
 * `POST /participant/{id}/favorite` добавляет, `DELETE` убирает, а признак
 * приходит в карточке полями `is_favorite` и `favorited_me`.
 *
 * На 21 августа 2026 маршрута ещё нет: и POST, и DELETE отдают карточку
 * участника — тот же ответ, что `GET /participant/{id}`, хвост пути сервер
 * отбрасывает. Готовность проверяется скриптом `tools/check-favorite-api.mjs`,
 * а до неё выбор хранится в localStorage.
 *
 * Ключ отдельный от `exh-{exhID}-marked`, где лежат отметки экспонентов.
 * Тот список пишется целиком: `ListExhibitorsView` держит в памяти только
 * записи с `type: 'exhibitors'` и сохраняет обратно их одни, так что чужие
 * записи в нём затираются при первом же нажатии закладки у экспонента.
 * Проверено на стенде. Поэтому избранное участников живёт в своём ключе.
 *
 * Когда бэк будет готов: FAVORITE_API_READY = true. Хранилище, функции вокруг
 * него и весь этот комментарий тогда убираются вместе с эмулятором в
 * `demo/demoParticipantCatalog.js`.
 */
export const FAVORITE_API_READY = true;

/** Ключ хранилища отметок. Уходит вместе с заглушкой. */
export function favoriteStorageKey(exhId) {
  return `exh-${exhId}-favorite-participants`;
}

/**
 * Идентификаторы участников, отмеченных пользователем. Уходит вместе с
 * заглушкой; вынесено из миксина, чтобы эмулятор каталога читал те же отметки,
 * а не заводил себе второй такой же ключ.
 */
export function readFavoriteIds(exhId) {
  const raw = localStorage.getItem(favoriteStorageKey(exhId));
  if (!raw) return [];
  try {
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list.filter((id) => id != null) : [];
  } catch (e) {
    return [];
  }
}

export default {
  mixins: [api],

  methods: {
    /**
     * Ставит или снимает отметку. Возвращает промис с итоговым состоянием,
     * чтобы вызывающий не гадал, что получилось.
     */
    setFavorite(id, state) {
      if (!FAVORITE_API_READY) {
        const exhId = this.$store.getters.getExhId;
        const ids = readFavoriteIds(exhId);
        const next = state
          ? [...new Set([...ids, id])]
          : ids.filter((item) => item !== id);
        localStorage.setItem(favoriteStorageKey(exhId), JSON.stringify(next));
        return Promise.resolve(state);
      }

      return this.baseAxios({
        method: state ? 'post' : 'delete',
        url: `${this.$store.getters.apiBasePath}/participant/${id}/favorite`,
      })
        .then(() => state)
        .catch((error) => Promise.reject(error));
    },
  },
};
